import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

/**
 * Copyright IBM Corp. 2022, 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import { pkg } from '../../../settings'; // Removes the cell selection elements

export var removeCellSelections = function removeCellSelections(_ref) {
  var matcher = _ref.matcher,
      spreadsheetRef = _ref.spreadsheetRef,
      _ref$blockClass = _ref.blockClass,
      blockClass = _ref$blockClass === void 0 ? "".concat(pkg.prefix, "--data-spreadsheet") : _ref$blockClass;

  if (matcher && typeof matcher === 'string') {
    var selectionToRemove = spreadsheetRef.current.querySelector("[data-matcher-id=\"".concat(matcher, "\"]"));

    if (selectionToRemove) {
      selectionToRemove.remove();
    }
  } else {
    var cellSelections = spreadsheetRef.current.querySelectorAll(".".concat(blockClass, "__selection-area--element"));

    _toConsumableArray(cellSelections).forEach(function (element) {
      return element.remove();
    });
  }
};